import _ from 'lodash';
import React from 'react';

import StandardItemDisplay from './StandardItemDisplay';
import CatchErrors from "../../../Utility/CatchErrors";

/**
 * A list of non-clustered, non-universal items. Each one gets an
 * add-to-cart.
 *
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function StandardItemList({
  itemApplications = [],
  products = {},
  shoppingCart = {},
  allProductSpecs = [],
}) {
  if (_.isEmpty(itemApplications))
    return null;

  const cartIndex = _.keyBy((shoppingCart && shoppingCart.cartItems), 'productId');

  return (
    <div className="standard-item-list">
      {itemApplications.map((app) => {
        const productId = app.productId || app.product_id;

        //if (_.isEmpty(specs)) {
        //  alert("no specs for " + productId + " " + JSON.stringify(allProductSpecs, null, 2) + "")
        //} else {
        //  console.log("specs is " + JSON.stringify(specs, null, 2) + "")
        //}
        return <CatchErrors key={app.id}>
          <StandardItemDisplay key={app.id}
            cartItem={cartIndex[productId] || null}
            shoppingCart={shoppingCart}
            product={products[productId]}
            application={app}
            allProductSpecs={allProductSpecs}
          /></CatchErrors>
      })}
    </div>
  );
}

